(function(){
    let guidePupopScrollY = 0;

    function lockGuidePupopScroll() {
        guidePupopScrollY = window.scrollY;
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + guidePupopScrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.documentElement.classList.add('guide-pupop-open');
    }

    function unlockGuidePupopScroll() {
        if (!document.documentElement.classList.contains('guide-pupop-open')) return;
        document.body.style.position = '';
        document.body.style.top = '';
        document.body.style.left = '';
        document.body.style.right = '';
        document.body.style.width = '';
        document.documentElement.classList.remove('guide-pupop-open');
        window.scrollTo(0, guidePupopScrollY);
    }

    window.unlockGuidePupopScroll = unlockGuidePupopScroll;

    function normalizeGuideText(text) {
        return (text || '').replace(/\s+/g, ' ').trim();
    }

    function getTextBeforeNode(node) {
        var text = '';
        var cur = node.previousSibling;
        while (cur) {
            if (cur.nodeType === 3) {
                text = cur.textContent + text;
            } else if (cur.nodeType === 1) {
                if (cur.tagName === 'BR' || (cur.classList && cur.classList.contains('guide_pupop_size_image_text_br'))) {
                    break;
                }
                text = (cur.textContent || '') + text;
            }
            cur = cur.previousSibling;
        }
        return normalizeGuideText(text);
    }

    function isMeasurementTitleLine(text) {
        var t = normalizeGuideText(text);
        if (!t || t.length > 48) {
            return false;
        }
        if (/[.!?]$/.test(t)) {
            return false;
        }
        if (!/[A-Za-z]/.test(t)) {
            return false;
        }
        return t === t.toUpperCase();
    }

    function getTextAfterNode(node) {
        var text = '';
        var cur = node.nextSibling;
        while (cur) {
            if (cur.nodeType === 3) {
                text += cur.textContent;
            } else if (cur.nodeType === 1) {
                if (cur.tagName === 'BR' || (cur.classList && cur.classList.contains('guide_pupop_size_image_text_br'))) {
                    break;
                }
                text += cur.textContent || '';
            }
            cur = cur.nextSibling;
        }
        return normalizeGuideText(text);
    }

    function isDisclaimerParagraph(el) {
        var t = normalizeGuideText(el.innerText || el.textContent);
        if (!t) {
            return false;
        }
        if (/FRONT LENGTH|BACK LENGTH|SLEEVE LENGTH|HEM CIRCUMFERENCE|SHOULDER WIDTH|THIGH CIRCUMFERENCE|SKIRT LENGTH|FRONT RISE|RAGLAN/i.test(t)) {
            return false;
        }
        if (isMeasurementTitleLine(t.split('\n')[0]) && t.indexOf('\n') >= 0) {
            return false;
        }
        if (isMeasurementTitleLine(t) && t.indexOf('\n') < 0) {
            return false;
        }
        if (/^all measurements are taken/i.test(t)) {
            return true;
        }
        if (/^measurements are intended/i.test(t)) {
            return true;
        }
        return false;
    }

    function getBlockChildren(field) {
        return Array.prototype.filter.call(field.children, function (el) {
            return el.nodeType === 1 && /^(P|H[1-6])$/i.test(el.tagName);
        });
    }

    function mergeDisclaimerParagraphs(field) {
        var blockChildren = getBlockChildren(field);
        var i = 0;
        while (i < blockChildren.length - 1) {
            var current = blockChildren[i];
            var next = blockChildren[i + 1];
            if (!(isDisclaimerParagraph(current) && isDisclaimerParagraph(next))) {
                break;
            }
            var tail = normalizeGuideText(current.textContent);
            var head = normalizeGuideText(next.textContent);
            if (tail && head && !/[\s]$/.test(current.textContent) && !/^[.,!?;:]/.test(head)) {
                current.appendChild(document.createTextNode(' '));
            }
            while (next.firstChild) {
                current.appendChild(next.firstChild);
            }
            next.parentNode.removeChild(next);
            current.classList.add('guide_pupop_size_image_text_disclaimer');
            blockChildren = getBlockChildren(field);
        }
        blockChildren = getBlockChildren(field);
        if (blockChildren[0] && isDisclaimerParagraph(blockChildren[0])) {
            blockChildren[0].classList.add('guide_pupop_size_image_text_disclaimer');
        }
    }

    function isDisclaimerSoftBreak(br) {
        var before = getTextBeforeNode(br);
        var after = getTextAfterNode(br);
        if (!before || !after) {
            return false;
        }
        if (/^all measurements are taken/i.test(before) && /[.!?]$/.test(before) && /^measurements are intended/i.test(after)) {
            return true;
        }
        if (/^measurements are intended/i.test(before) && /[.!?]$/.test(before) && /^all measurements are taken/i.test(after)) {
            return true;
        }
        return false;
    }

    function wrapMeasurementTitleLines(root) {
        root.querySelectorAll('.guide_pupop_size_image_text_br').forEach(function (span) {
            if (!span.parentNode) {
                return;
            }
            var prev = span.previousSibling;
            while (prev && prev.nodeType === 3 && !normalizeGuideText(prev.textContent)) {
                prev = prev.previousSibling;
            }
            if (!prev) {
                return;
            }
            if (prev.nodeType === 3 && isMeasurementTitleLine(prev.textContent)) {
                var titleSpan = document.createElement('span');
                titleSpan.className = 'guide_pupop_size_image_text_title';
                prev.parentNode.insertBefore(titleSpan, prev);
                titleSpan.appendChild(prev);
                return;
            }
            if (
                prev.nodeType === 1 &&
                prev.classList &&
                !prev.classList.contains('guide_pupop_size_image_text_title') &&
                !prev.classList.contains('guide_pupop_size_image_text_br') &&
                !prev.classList.contains('guide_pupop_size_image_text_gap') &&
                isMeasurementTitleLine(prev.textContent)
            ) {
                prev.classList.add('guide_pupop_size_image_text_title');
            }
        });
        var field = root.querySelector('.metafield-rich_text_field') || root;
        getBlockChildren(field).forEach(function (block) {
            if (block.classList.contains('guide_pupop_size_image_text_disclaimer')) {
                return;
            }
            if (block.querySelector('.guide_pupop_size_image_text_title')) {
                return;
            }
            if (
                isMeasurementTitleLine(block.textContent) &&
                !block.querySelector('.guide_pupop_size_image_text_br, .guide_pupop_size_image_text_gap')
            ) {
                block.classList.add('guide_pupop_size_image_text_title');
            }
        });
    }

    window.updateGuideFitAxisLabels = function updateGuideFitAxisLabels(scope) {
        var roots = scope
            ? [scope]
            : Array.prototype.slice.call(document.querySelectorAll('.guide_pupop_content-gui_pupop_tab3'));
        roots.forEach(function (root) {
            if (!root || !root.querySelector) {
                return;
            }
            var labelEl = root.querySelector('.guide_pupop_fit_axis_bust_label');
            if (!labelEl) {
                return;
            }
            var showIn = root.classList.contains('guide_pupop_fit_show_in');
            var table = root.querySelector(
                showIn
                    ? '.guide_pupop_fit_details_in table'
                    : '.guide_pupop_fit_details_cm table'
            );
            if (!table) {
                table = root.querySelector('.guide_pupop_fit_details_cm table, .guide_pupop_fit_details_in table');
            }
            if (!table) {
                return;
            }
            var cell = table.querySelector(
                'thead tr:first-child th:first-child, thead tr:first-child td:first-child, tr:first-child th:first-child, tr:first-child td:first-child'
            );
            if (!cell) {
                return;
            }
            var label = (cell.textContent || '')
                .replace(/\s*\(\s*(cm|in)\s*\)\s*/gi, ' ')
                .replace(/\s+/g, ' ')
                .trim();
            if (!label || /^\d/.test(label) || label === '/' || label === '-') {
                return;
            }
            labelEl.textContent = label;
        });
    };

    window.formatGuideSizeImageText = function formatGuideSizeImageText() {
        $('.guide_pupop_size_image_text').each(function () {
            var root = this;
            if (root.getAttribute('data-guide-spaced') === '3') {
                return;
            }
            var field = root.querySelector('.metafield-rich_text_field') || root;
            if (root.getAttribute('data-guide-spaced') === '1' || root.getAttribute('data-guide-spaced') === '2') {
                root.querySelectorAll('.guide_pupop_size_image_text_br').forEach(function (el) {
                    el.style.height = '';
                    el.style.minHeight = '';
                    el.style.lineHeight = '';
                });
            }
            if (!root.getAttribute('data-guide-spaced') || root.getAttribute('data-guide-spaced') === '1') {
                mergeDisclaimerParagraphs(field);
                root.querySelectorAll('br').forEach(function (br) {
                    if (!br.parentNode) {
                        return;
                    }
                    if (isDisclaimerSoftBreak(br)) {
                        br.parentNode.replaceChild(document.createTextNode(' '), br);
                        return;
                    }
                    var before = getTextBeforeNode(br);
                    var after = getTextAfterNode(br);
                    if (isMeasurementTitleLine(before)) {
                        var titleGap = document.createElement('span');
                        titleGap.className = 'guide_pupop_size_image_text_br';
                        titleGap.setAttribute('aria-hidden', 'true');
                        br.parentNode.replaceChild(titleGap, br);
                        return;
                    }
                    if (isMeasurementTitleLine(after)) {
                        var prev = br.previousSibling;
                        while (prev && prev.nodeType === 3 && !normalizeGuideText(prev.textContent)) {
                            prev = prev.previousSibling;
                        }
                        if (prev && prev.nodeType === 1 && prev.classList && prev.classList.contains('guide_pupop_size_image_text_gap')) {
                            br.parentNode.removeChild(br);
                            return;
                        }
                        var groupGap = document.createElement('span');
                        groupGap.className = 'guide_pupop_size_image_text_gap';
                        groupGap.setAttribute('aria-hidden', 'true');
                        br.parentNode.replaceChild(groupGap, br);
                    }
                });
            }
            wrapMeasurementTitleLines(root);
            root.setAttribute('data-guide-spaced', '3');
        });
    };

    function measureGuideTabNeedsWrap(tab) {
        var cs = window.getComputedStyle(tab);
        var probe = document.createElement('span');
        probe.textContent = (tab.textContent || '').replace(/\s+/g, ' ').trim();
        probe.style.cssText = [
            'position:absolute',
            'visibility:hidden',
            'pointer-events:none',
            'white-space:nowrap',
            'left:-9999px',
            'top:0',
            'font-size:' + cs.fontSize,
            'font-family:' + cs.fontFamily,
            'font-weight:' + cs.fontWeight,
            'font-style:' + cs.fontStyle,
            'letter-spacing:' + cs.letterSpacing,
            'text-transform:' + cs.textTransform,
            'padding:0',
            'margin:0',
            'border:0'
        ].join(';');
        document.body.appendChild(probe);
        var textWidth = probe.offsetWidth;
        document.body.removeChild(probe);
        var pad = (parseFloat(cs.paddingLeft) || 0) + (parseFloat(cs.paddingRight) || 0);
        var available = tab.clientWidth - pad;
        return textWidth > available + 1;
    }

    window.updateGuideFitHeaderWrap = function updateGuideFitHeaderWrap() {
        var boxes = document.querySelectorAll('.guide_pupop_fit_details_cm, .guide_pupop_fit_details_in');
        boxes.forEach(function (box) {
            var table = box.querySelector('table');
            if (!table || table.offsetWidth === 0) return;
            var firstRow = table.querySelector('tr');
            if (!firstRow) return;
            var cells = Array.prototype.slice.call(firstRow.children, 1);
            if (!cells.length) return;
            var needWrap = false;
            cells.forEach(function (cell) {
                if (!cell.dataset.guideFitHeaderOriginal) {
                    cell.dataset.guideFitHeaderOriginal = cell.innerHTML;
                }
                if (measureGuideTabNeedsWrap(cell)) {
                    needWrap = true;
                }
            });
            cells.forEach(function (cell) {
                var text = (cell.textContent || '').replace(/\s+/g, ' ').trim();
                var match = text.match(/^([^\s-]+)-([^\s-]+)$/);
                if (needWrap && match) {
                    cell.innerHTML = match[1] + '-<br>' + match[2];
                } else {
                    cell.innerHTML = cell.dataset.guideFitHeaderOriginal;
                }
            });
        });
    };

    window.updateGuideTabsSpacing = function updateGuideTabsSpacing() {
        var rows = document.querySelectorAll('.guide-pupop-content .guide_pupop_tabs');
        rows.forEach(function (row) {
            var box = row.closest('.product-tabs-box');
            row.classList.remove('guide_pupop_tabs--compact');
            if (box) {
                box.classList.remove('guide_pupop_tabs_box--compact');
            }
            void row.offsetWidth;
            var tabs = row.querySelectorAll('.product-tabs-tab');
            var need = false;
            tabs.forEach(function (tab) {
                if (measureGuideTabNeedsWrap(tab)) {
                    need = true;
                }
            });
            if (need) {
                row.classList.add('guide_pupop_tabs--compact');
                if (box) {
                    box.classList.add('guide_pupop_tabs_box--compact');
                }
            }
        });
        window.updateGuideTabIndicatorLine();
        window.updateGuideFitHeaderWrap();
    };

    window.updateGuideTabIndicatorLine = function updateGuideTabIndicatorLine(activeTab, animate) {
        var tab = activeTab;
        if (!tab) {
            tab = document.querySelector('.guide-pupop-content .guide_pupop_tabs .product-tabs-tab.active');
        }
        if (!tab) {
            tab = document.querySelector('.guide-pupop-content .guide_pupop_tabs .product-tabs-tab');
        }
        if (!tab) return;
        var lineClass = tab.getAttribute('data-line-class') || 'gui_pupop_tab_line';
        var line = document.querySelector('.' + lineClass + ' .product-tabs-linebox-line');
        if (!line) return;
        var track = line.parentElement;
        if (!track) return;
        var count = tab.parentElement ? tab.parentElement.querySelectorAll('.product-tabs-tab').length : 3;
        if (window.innerWidth > 768 || count === 2) {
            var step = count === 2 ? 50 : 33.33;
            var idx = Array.prototype.indexOf.call(tab.parentElement.children, tab);
            if (idx < 0) idx = 0;
            if (animate !== false && window.gsap) {
                gsap.to(line, {
                    left: idx * step + '%',
                    width: step + '%',
                    duration: 0.5
                });
            } else {
                line.style.left = idx * step + '%';
                line.style.width = step + '%';
            }
            return;
        }
        var trackRect = track.getBoundingClientRect();
        var tabRect = tab.getBoundingClientRect();
        var left = tabRect.left - trackRect.left;
        var width = tabRect.width;
        if (animate !== false && window.gsap) {
            gsap.to(line, {
                left: left,
                width: width,
                duration: 0.5
            });
        } else {
            line.style.left = left + 'px';
            line.style.width = width + 'px';
        }
    };

    var guideTabsResizeTimer;
    window.addEventListener('resize', function () {
        clearTimeout(guideTabsResizeTimer);
        guideTabsResizeTimer = setTimeout(function () {
            window.updateGuideTabsSpacing();
        }, 100);
    });

    $('.product-tabs-box .product-tabs .product-tabs-tab').on('click',function(){
        var idx = $(this).index();
        var name = $(this).attr('data-name');
        var form_name =$(this).attr('data-form_name')
        var custom_class = $(this).attr('data-line-class');
        var data_content = $(this).attr('data-content');
        var max_length = $(this).attr('max-length');
        var data_form_name = $(this).parent().attr('data-form_name');
        var setp;
        if (data_form_name == 'guide_tabs') {
            var guide_tab_count = $(this).parent().find('.product-tabs-tab').length;
            setp = guide_tab_count == 2 ? 50 : 33.33;
        } else {
            setp = 20;
        }
       if(form_name == 'guide_tabs' || data_form_name == 'guide_tabs'){
        
         $('.product-tabs-box .guide_pupop_tabs .product-tabs-tab').not($(this)).removeClass('active');
        $(this).addClass('active');
            if (window.gsap && typeof gsap.to === 'function') {
                gsap.to('.product-tabs-box .guide_pupop_tabs', {
                    duration: 1, 
                    scrollTo: {
                        x: $(this), 
                        offsetX: 20 
                    },
                    ease: "power2.out"
                });
            }
         
       }
       if(data_form_name == 'product_tabs'){
           if($('.'+data_content)){
                var left_value = idx==0? '0%': idx==1? '22%': idx==2? '42%': idx==3? '62%': idx==4? '82%': '0%';
                gsap.to('.'+custom_class+' .product-tabs-linebox-line',{
                    left: left_value,
                    duration: 0.5
                });
                $('.'+data_content).hide();
              
                $('.'+data_content+'-'+name).show(300);
            }

        }else{
           if($('.'+data_content)){
              if (data_form_name == 'guide_tabs') {
                  window.updateGuideTabIndicatorLine(this, true);
              } else {
                  gsap.to('.'+custom_class+' .product-tabs-linebox-line',{
                      left: idx*setp+'%',
                      duration: 0.5
                  });
              }
              $('.'+data_content).hide();
            
              $('.'+data_content+'-'+name).show(300);
          }

       }

       
       
    })
    $('.product-tabs-content-guide-btn').on('click',function(){
        if($('.guide-pupop-box').length){
            lockGuidePupopScroll();
            $('.guide-pupop-box').fadeIn(300);
            setTimeout(function () {
                window.formatGuideSizeImageText();
                window.updateGuideFitAxisLabels();
                window.updateGuideTabsSpacing();
            }, 50);
        }
    })
    $('.product-tabs-box .fabric_image').on('click',function(){
        var index = $(this).parent().index();
        console.log(index)
        $('.fabric_image_list_item_imgbox').hide();
        $('.fabric-pupop-desc-item').hide();
        $('.fabric_image_list_item_imgbox').eq(index).fadeIn(300);
        $('.fabric-pupop-desc-item').eq(index).fadeIn(300);
         $('.fabric-pupop-box').fadeIn(300);
         
    })
   

    $('#select_size_button').on('click',function(){
        gsap.to('.add-to-card-pupop-content',{
            height: 'auto',
            duration: 0.5,
            ease: 'power2.inOut'
        });
        $('.add-to-card-pupop').addClass('active')
        gsap.to('.add-to-card-pupop-btn',{
            background: '#545454',
             duration: 0.5,
        })

    })


    $('.add-to-card-sizebox-item label').on('click',function(){
         e.preventDefault();
  e.stopPropagation();
        // var is_disable = $(this).attr('data-disabled');
        // $('.add-to-card-sizebox-item label').not($(this)).removeClass('active')
        // $(this).addClass('active')
       
        // if(is_disable == 'true'){
        //     $('#add-to-card-pupop-btn-card').text('ADD TO CART').attr('disabled',false);
        // }else{
        //     $('#add-to-card-pupop-btn-card').text('SOLD OUT').attr('disabled',true);
        // }
    })
     $('#add-to-card-pupop-btn-card').on('click',function(){
        if(!$(this).attr('disabled')){
             $('.product buy-buttons button[type="submit"').click();
        }
     })
    
     $('.guide_pupop_merged_switch').on('click',function(e){
        e.stopPropagation();
        $(this).closest('.guide_pupop_merged_reference').toggleClass('guide_pupop_merged_show_in');
     })

     $('.guide_pupop_top_cm_in_switch').on('click','.guide_pupop_body_measurements_switch_item',function(e){
        e.stopPropagation();
        const nextUnit = $(this).attr('data-unit');
        if (!nextUnit || nextUnit === currentUnit) return;
        toggleUnits();
        const $switch = $(this).closest('.guide_pupop_top_cm_in_switch');
        $switch.attr('data-active', currentUnit);
        $switch.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
        $switch.find('[data-unit="' + currentUnit + '"]').addClass('is-active');
      })

      $('.guide_pupop_fit_switch').on('click','.guide_pupop_body_measurements_switch_item',function(e){
        e.stopPropagation();
        const nextUnit = $(this).attr('data-unit');
        const $switch = $(this).closest('.guide_pupop_fit_switch');
        if (!nextUnit || $switch.attr('data-active') === nextUnit) return;
        $switch.attr('data-active', nextUnit);
        $switch.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
        $(this).addClass('is-active');
        const $tab = $(this).closest('.guide_pupop_content-gui_pupop_tab3');
        if (nextUnit === 'in') {
          $tab.addClass('guide_pupop_fit_show_in');
        } else {
          $tab.removeClass('guide_pupop_fit_show_in');
        }
        if (typeof window.updateGuideFitAxisLabels === 'function') {
          window.updateGuideFitAxisLabels($tab[0]);
        }
        if (typeof window.updateGuideFitHeaderWrap === 'function') {
          window.updateGuideFitHeaderWrap();
        }
      })

      $('.guide_pupop_body_measurements_table .guide_pupop_body_measurements_switch').on('click','.guide_pupop_body_measurements_switch_item',function(e){
        e.stopPropagation();
        const tableBox = $(this).closest('.guide_pupop_body_measurements_table');
        if (!tableBox.length) return;
        const currentBodyMeasurementsUnit = tableBox.attr('data-guide-body-measurements-unit') || 'cm';
        const nextBodyMeasurementsUnit = $(this).attr('data-unit');
        if (!nextBodyMeasurementsUnit || nextBodyMeasurementsUnit === currentBodyMeasurementsUnit) return;

        tableBox.attr('data-guide-body-measurements-unit', nextBodyMeasurementsUnit);
        tableBox.find('.guide_pupop_body_measurements_switch').attr('data-active', nextBodyMeasurementsUnit);
        tableBox.find('.guide_pupop_body_measurements_switch_item').removeClass('is-active');
        $(this).addClass('is-active');
        tableBox.find('tbody tr').each(function(){
          const cells = Array.from(this.querySelectorAll('td'));
          if (!cells.length) return;

          const firstCellText = cells[0].innerText.trim();
          const measurementStartIndex = firstCellText && !isNaN(firstCellText) ? 1 : 2;

          cells.slice(measurementStartIndex).forEach((cell) => {
            if (!cell.dataset.guideBodyMeasurementsCm) {
              cell.dataset.guideBodyMeasurementsCm = cell.innerText.trim();
            }

            const cmValue = parseFloat(cell.dataset.guideBodyMeasurementsCm);
            if (isNaN(cmValue)) return;

            cell.innerText = nextBodyMeasurementsUnit === 'in' ? Math.round(cmValue * 0.393701) : cell.dataset.guideBodyMeasurementsCm;
          });
        });
      })

    var guideTableHoverSelector = '.guide_pupop_conversion_table table, .guide_pupop_fit_details_cm table, .guide_pupop_fit_details_in table';
    var guideTableCellSelector = '.guide_pupop_conversion_table th, .guide_pupop_conversion_table td, .guide_pupop_fit_details_cm th, .guide_pupop_fit_details_cm td, .guide_pupop_fit_details_in th, .guide_pupop_fit_details_in td';

    function buildGuideTableMatrix(table) {
      var matrix = [];
      var rowCount = table.rows.length;
      var r;
      for (r = 0; r < rowCount; r++) {
        matrix[r] = [];
      }
      for (r = 0; r < rowCount; r++) {
        var col = 0;
        var cells = table.rows[r].cells;
        for (var i = 0; i < cells.length; i++) {
          var cell = cells[i];
          while (matrix[r][col]) {
            col++;
          }
          var rowSpan = cell.rowSpan || 1;
          var colSpan = cell.colSpan || 1;
          var ri;
          var ci;
          for (ri = 0; ri < rowSpan; ri++) {
            if (!matrix[r + ri]) {
              matrix[r + ri] = [];
            }
            for (ci = 0; ci < colSpan; ci++) {
              matrix[r + ri][col + ci] = cell;
            }
          }
          col += colSpan;
        }
      }
      return matrix;
    }

    function clearGuideTableHighlight(table) {
      table.querySelectorAll('.guide-table-hl').forEach(function(cell) {
        cell.classList.remove('guide-table-hl');
      });
    }

    function getGuideTableCellPosition(matrix, targetCell) {
      for (var r = 0; r < matrix.length; r++) {
        for (var c = 0; c < matrix[r].length; c++) {
          if (matrix[r][c] === targetCell) {
            return { row: r, col: c };
          }
        }
      }
      return null;
    }

    function highlightGuideTableCross(table, targetCell) {
      clearGuideTableHighlight(table);
      var matrix = buildGuideTableMatrix(table);
      var pos = getGuideTableCellPosition(matrix, targetCell);
      if (!pos) return;
      var highlighted = new Set();
      function shouldSkipTitleCell(cell) {
        return cell && cell.colSpan > 1 && cell.parentElement && cell.parentElement.parentElement && cell.parentElement.parentElement.tagName === 'THEAD';
      }
      var c;
      for (c = 0; c < matrix[pos.row].length; c++) {
        var rowCell = matrix[pos.row][c];
        if (rowCell && !highlighted.has(rowCell) && !shouldSkipTitleCell(rowCell)) {
          rowCell.classList.add('guide-table-hl');
          highlighted.add(rowCell);
        }
      }
      var r;
      for (r = 0; r < matrix.length; r++) {
        var colCell = matrix[r][pos.col];
        if (colCell && !highlighted.has(colCell) && !shouldSkipTitleCell(colCell)) {
          colCell.classList.add('guide-table-hl');
          highlighted.add(colCell);
        }
      }
    }

    $(document).on('mouseover', guideTableCellSelector, function() {
      var table = this.closest('table');
      if (!table) return;
      highlightGuideTableCross(table, this);
    });

    $(document).on('mouseleave', guideTableHoverSelector, function() {
      clearGuideTableHighlight(this);
    });

       let currentUnit = 'cm';

    function getSizeGuideSkipRows(row) {
      const table = row.closest('table');
      const skipRows = table ? table.getAttribute('data-size-guide-skip-unit-rows') : '';
      return skipRows ? skipRows.split(',').map((item) => item.trim().toUpperCase()).filter(Boolean) : [];
    }

    function getSizeGuideRowName(row) {
      const firstCell = row.querySelector('td');
      return firstCell ? firstCell.innerText.split('(')[0].trim() : '';
    }

    function shouldSkipSizeGuideUnitRow(row) {
      const rowName = getSizeGuideRowName(row).toUpperCase();
      return getSizeGuideSkipRows(row).includes(rowName);
    }

    function shouldUseSizeGuideDecimalConversion(row) {
      const table = row.closest('table');
      const decimalConversion = table ? table.getAttribute('data-size-guide-decimal-conversion') : '';
      return decimalConversion === '1' || decimalConversion === 'true';
    }

    function formatSizeGuideConvertedValue(value, row) {
      return shouldUseSizeGuideDecimalConversion(row) ? value.toFixed(1) : Math.round(value.toFixed(2));
    }

    function getSizeGuideOriginalCellText(cell) {
      if (!cell.dataset.sizeGuideOriginalValue) {
        cell.dataset.sizeGuideOriginalValue = cell.innerText.trim();
      }
      return cell.dataset.sizeGuideOriginalValue;
    }

    // 切换单位的函数
    function toggleUnits() {
        
    
      const rows = document.querySelectorAll('#sizeTableBody tr');

      // 遍历所有表格行
      rows.forEach((row,index) => {
         if (index === rows.length - 1) return;
        const cells = row.querySelectorAll('td');
        const skipUnitRow = shouldSkipSizeGuideUnitRow(row);

        // 获取当前行的第一个单元格（用于显示单位）
        const firstCell = row.querySelector('td');
        // console.log('单位')
        // console.log(currentUnit)
        // 更新第一个单元格的单位
        if (firstCell && !skipUnitRow) {
          const text = firstCell.innerText.split('(')[0].trim();
          if (firstCell.closest('.guide_pupop_details_cm')) {
            firstCell.innerText = text;
          } else {
            firstCell.innerText = `${text} (${currentUnit})`;
          }
        }

        // 遍历每个单元格，转换数据
        if (skipUnitRow) return;

        cells.forEach((cell,idx) => {
             
          const text = cell.innerText.trim();

          // 只处理包含数值的单元格，不处理 '/' 或空单元格
          if (text && !isNaN(text) && text !== '/') {
            let value = parseFloat(text);
            if (shouldUseSizeGuideDecimalConversion(row)) {
              const originalText = getSizeGuideOriginalCellText(cell);
              value = parseFloat(originalText);
              cell.innerText = currentUnit === 'cm' ? formatSizeGuideConvertedValue(value * 0.393701, row) : originalText;
              return;
            }

            // 如果当前单位是cm，转换为inches
            if (currentUnit === 'cm') {
              const inchValue = formatSizeGuideConvertedValue(value * 0.393701, row);
              cell.innerText = inchValue; // 更新为英寸
            }
            // 如果当前单位是inches，转换为cm
            else {
              const cmValue = formatSizeGuideConvertedValue(value / 0.393701, row);
              cell.innerText = cmValue; // 更新为厘米
            }
          }

        //    if (cell.innerText) {
        //         let updatedText = cell.innerText;
        //         updatedText = updatedText.replace(/\bcm\b/gi, currentUnit === 'cm' ? 'in' : 'cm');
        //         updatedText = updatedText.replace(/\bin\b/gi, currentUnit === 'cm' ? 'cm' : 'in');
        //         cell.innerText = updatedText;
        //     }
        });
      });

      // 切换单位
      currentUnit = currentUnit === 'cm' ? 'in' : 'cm';

      // 更新单位显示
    //   document.getElementById('unitDisplay').innerText = `Current unit: ${currentUnit}`;

      // 更新表头单位
      updateUnitInHeader();
    }

    // 更新表头单位
    function updateUnitInHeader() {
      const headers = document.querySelectorAll('#sizeTableBody tr');
      
      headers.forEach((header,index) => {
        if (index === headers.length - 1) return;
        let td = header.querySelector('td');
        // 获取第一列（行标题）并更新单位
        if (td && !shouldSkipSizeGuideUnitRow(header)) {
          const text = td.innerText.split('(')[0].trim();
          if (td.closest('.guide_pupop_details_cm')) {
            td.innerText = text;
          } else {
            td.innerText = `${text} (${currentUnit})`;
          }
        }
      });
    }

    // //notify me click
    // $('.notify_me_text').on('click',function(){
    //     console.log('点击进来的')
    //     $('.add-to-card-pupop').fadeOut(400);
    //     $('.notify-me-pupopbox').fadeIn(300);
    //     var notify_product_size_name = $(this).attr('data-name');
    //     $('#notify_form_product_size').val(notify_product_size_name);
    // })
    // $('.notify-me-pupop-btn').on('click',function(){
    //     $('.notify-me-pupopbox').fadeOut(400)
    //     $('.add-to-card-pupop').fadeIn(300)
        
    // })

    // $('.notify-me-submitbox button[type="submit"]').on('click',function(){
    //     localStorage.setItem('notify_succsess',true)
    // })

  
      $(document).ready(function() {
        $('#add-to-card-pupop-btn-card').text($('.product buy-buttons button[type="submit"] button-content').attr('up-text'));
        $('#add-to-card-pupop-btn-card').attr("disabled",$('.product buy-buttons button[type="submit"]').attr('disabled')) 
        
        console.log(localStorage.getItem('notify_succsess'))
       if(localStorage.getItem('notify_succsess')){
            $('.add-to-card-pupop').fadeOut(300);
            $('.notify-me-pupopbox').fadeIn(400);
            localStorage.removeItem('notify_succsess');
        }
       
        //获取 scroll-carousel 下的 product-gallery__media
    //     let product_media_length = $('product-gallery scroll-carousel .product-gallery__media:not([hidden])').length;
    //    var product_media_indicator_item = '';
    //     for(var indicator=0;indicator<product_media_length;indicator++){
    //         product_media_indicator_item+='<div class="indicator-box-item"></div>'
    //     }
    //     $('.indicator-box').html(product_media_indicator_item);


        // $('.variant-picker__option-values-color"]').on('click',function(){
        //    console.log('点解了')
        // })


        $('.indicator-box .indicator-box-item').on('click',function(){
           let  indicator_index = $(this).index();
            if(window.innerWidth > 1000){
                    gsap.to(window, {
                        duration: 1,
                        scrollTo: {
                            y: document.querySelectorAll('product-gallery scroll-carousel .product-gallery__media:not([hidden])')[indicator_index],
                            offsetY: 20
                        },
                        ease: "power2.out"
                    });
            }
                
        })

        window.formatGuideSizeImageText();
        window.updateGuideFitAxisLabels();
        window.updateGuideTabsSpacing();
        window.updateGuideTabIndicatorLine(null, false);
        $(document).on('click', '.product-tabs-box .guide_pupop_tabs .product-tabs-tab', function () {
            setTimeout(function () {
                window.formatGuideSizeImageText();
                window.updateGuideFitAxisLabels();
            }, 50);
            setTimeout(function () {
                window.updateGuideFitHeaderWrap();
            }, 350);
        });
    });
    
    //使用gsap 页面滚动到 class .product 距离结束 20 的位置 add-to-card-pupop 隐藏，回滚进入 .product 位置 add-to-card-pupop 显示



})();
